const SuggestionTypes = {
    REMOVABLE: 0,
    IMPROVABLE: 1,
};

export { SuggestionTypes };